<template>
  <div>
    <el-dialog
      width="1200px"
      title="选择招标文件"
      :visible.sync="showDialogVisible"
      custom-class="revenue-code-number"
    >
      <div class="el-dialog__body-bodys" v-if="showDialogVisible">
        <div class="container ">
          <!--搜索条件开始-->
          <div class="ccui-advanced-search-wrapper">
            <el-search
              ref="elSearch"
              :formProp="formData"
              @search="inventorySearch"
              @resetForm="resetParams"
              width="400px"
              :isShowSearch="true"
              :selectClear="true"
              :spoNum="2"
            >
              <template slot="search">
                <el-input
                  v-model.trim="formData.fileName"
                  clearable
                  searchLabel="招标文件名称"
                  placeholder="请输入招标文件名称模糊查询"
                ></el-input>
                <el-input
                  v-model.trim="formData.packName"
                  clearable
                  searchLabel="包件名称"
                  placeholder="请输入包件名称模糊查询"
                ></el-input>
              </template>
              <el-input
                v-model.trim="formData.fileName"
                clearable
                searchLabel="招标文件名称"
                placeholder="请输入招标文件名称模糊查询"
                slot="searchItem1"
              ></el-input>
              <el-input
                v-model.trim="formData.packName"
                clearable
                searchLabel="包件名称"
                placeholder="请输入包件名称模糊查询"
                slot="searchItem2"
              ></el-input>
            </el-search>
          </div>

          <!--搜索条件结束-->

          <div class="ccui-multifunctional-table-wrapper">
            <el-table
              :data="inventoryTableDatas"
              @select="selectTable"
              @select-all="selectTableAll"
              ref="inventoryMultipleTable"
              height="200"
              border
              :fit="true"
            >
              <el-table-column width="35" type="selection" />
              <el-table-column label="序号" width="45" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(table, index) in tableHeadOptions"
                :fixed="table.fixed || false"
                :key="index"
                :type="table.type"
                :label="table.label"
                :min-width="table.width"
                :prop="table.prop"
                :align="table.align || 'left'"
                :header-align="table.headerAlign || 'left'"
                :filters="table.filters"
                :formatter="table.formatter"
                :show-overflow-tooltip="true"
              />
            </el-table>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="showDialogVisible = false"
          >取 消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="inventoryConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      width="1200px"
      title="选择投标文件"
      :visible.sync="showDialogVisible2"
      custom-class="revenue-code-number"
    >
      <div class="el-dialog__body-bodys" v-if="showDialogVisible2">
        <div class="container ">
          <!--搜索条件开始-->
          <div class="ccui-advanced-search-wrapper">
            <el-search
              ref="elSearch"
              :formProp="formData"
              @search="inventorySearch"
              @resetForm="resetParams"
              width="400px"
              :isShowSearch="true"
              :selectClear="true"
              :spoNum="2"
            >
              <template slot="search">
                <el-input
                  v-model.trim="formData.fileName"
                  clearable
                  searchLabel="投标文件名称"
                  placeholder="请输入投标文件名称模糊查询"
                ></el-input>
                <el-input
                  v-model.trim="formData.packName"
                  clearable
                  searchLabel="包件名称"
                  placeholder="请输入包件名称模糊查询"
                ></el-input>
              </template>
              <el-input
                v-model.trim="formData.fileName"
                clearable
                searchLabel="投标文件名称"
                placeholder="请输入投标文件名称模糊查询"
                slot="searchItem1"
              ></el-input>
              <el-input
                v-model.trim="formData.packName"
                clearable
                searchLabel="包件名称"
                placeholder="请输入包件名称模糊查询"
                slot="searchItem2"
              ></el-input>
            </el-search>
          </div>

          <!--搜索条件结束-->

          <div class="ccui-multifunctional-table-wrapper">
            <el-table
              :data="aiQuoteFileData"
              @select="selectTable2"
              @select-all="selectTableAll2"
              ref="inventoryMultipleTable"
              height="200"
              border
              :fit="true"
            >
              <el-table-column width="35" type="selection" />
              <el-table-column label="序号" width="45" fixed>
                <template slot-scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(table, index) in tableHeadaiQuoteFile"
                :fixed="table.fixed || false"
                :key="index"
                :type="table.type"
                :label="table.label"
                :min-width="table.width"
                :prop="table.prop"
                :align="table.align || 'left'"
                :header-align="table.headerAlign || 'left'"
                :filters="table.filters"
                :formatter="table.formatter"
                :show-overflow-tooltip="true"
              />
            </el-table>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="showDialogVisible2 = false"
          >取 消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="inventoryConfirm2"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="'AI清标'"
      :visible.sync="dialogVisible"
      width="1200px"
      height="70vh"
      class="yujing"
    >
      <iframe :src="AIUrl" frameborder="0" height="100%" width="100%"></iframe>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >关闭</el-button
        >
        <!--<el-button size="mini" type="primary-font-mini" @click="addRoleInfo()"-->
        <!--&gt;提交</el-button-->
        <!--&gt;-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  qryAiBidDocument,
  qryAiQuoteDocument,
  runAiBidClearTask,
  getAiClearAddress
} from "@/app/sourcingFlow/api/expertEvaluation";
export default {
  name: "AIfile",
  data() {
    return {
      showDialogVisible: false,
      dialogVisible: false,
      AIUrl: "",
      showDialogVisible2: false,
      tableHeadOptions: [
        {
          label: "招标文件名称",
          prop: "fileName",
          width: 200,
          fixed: true
        },
        {
          label: "包件名称",
          prop: "packName",
          width: 150
        },
        {
          label: "项目编号",
          prop: "schemeCode",
          width: 150
        },
        {
          label: "项目名称",
          prop: "schemeName",
          width: 150
        },
        {
          label: "填报单位",
          prop: "opUnitName",
          width: 180
        }
      ],
      tableHeadaiQuoteFile: [
        {
          label: "投标文件名称",
          prop: "fileName",
          width: 200,
          fixed: true
        },
        {
          label: "包件名称",
          prop: "packName",
          width: 150
        },
        // {
        //   label: "招标文件名称",
        //   prop: "fileName",
        //   width: 200
        // },
        {
          label: "供应商名称",
          prop: "supName",
          width: 200
        },
        {
          label: "项目编号",
          prop: "schemeCode",
          width: 150
        },
        {
          label: "项目名称",
          prop: "schemeName",
          width: 150
        },
        {
          label: "填报单位",
          prop: "opUnitName",
          width: 180
        }
      ],

      inventoryTableDatas: [],
      aiQuoteFileData: [], //投标文件数据
      aiBidFileList: [], //招标文件
      aiQuoteFileList: [], //投标文件
      formData: {
        fileName: "",
        packName: ""
      }
    };
  },
  watch: {
    showDialogVisible(val) {
      this.formData.fileName = "";
      this.formData.packName = "";
      if (val) {
        this.getList();
      }
    },
    showDialogVisible2() {
      this.formData.fileName = "";
      this.formData.packName = "";
    }
  },
  created() {
    this.getList();
  },
  props: {
    schemeId: {
      type: String,
      default() {
        return "";
      }
    },
    bidPriceId: {
      type: String,
      default: ""
    }
  },
  methods: {
    getList() {
      qryAiBidDocument({
        schemeId: this.schemeId,
        packName: this.formData.packName,
        fileName: this.formData.fileName
        // schemeId: "2599195702837981184"
      }).then(res => {
        if (res.data.data.data) {
          this.inventoryTableDatas = res.data.data.data;
        }
      });
    },
    getListtou() {
      qryAiQuoteDocument({
        schemeId: this.schemeId,
        // schemeId: "2593407053312016384",
        packId: this.aiBidFileList[0].packId,
        packName: this.aiBidFileList[0].packName,
        // bidPriceId:'2609359917660254208',
        bidPriceId: this.bidPriceId,
        isShowLoading: true,
        fileName: this.formData.fileName
      }).then(res => {
        if (res.data.data.data) {
          this.aiQuoteFileData = res.data.data.data;
        }
      });
    },
    inventorySearch(searchData) {
      if (this.showDialogVisible) {
        this.getList();
      } else {
        this.getListtou();
      }
    },
    inventoryConfirm() {
      let list = [],
        o = this.aiBidFileList;
      o.forEach(item => {
        if (item.packName) {
          list.push(item.packName);
        }
      });
      const uniqueArray = [...new Set(list)];
      if (uniqueArray.length > 1) {
        this.$message({
          message: "只能选择同一个包件的招标文件！",
          type: "error",
          duration: 3000,
          offset: document.documentElement.clientHeight / 2 - 21
        });
        return;
      }
      // if (o.length > 3) {
      //   this.$message({
      //     message: "一次最多选择3个招标文件",
      //     type: "error",
      //     duration: 3000,
      //     offset: document.documentElement.clientHeight / 2 - 21
      //   });
      //   return;
      // }
      this.showDialogVisible = false;
      this.$nextTick(() => {
        this.getListtou();
      });
      this.showDialogVisible2 = true;
    },
    inventoryConfirm2() {
      runAiBidClearTask({
        bidPriceId: this.bidPriceId,
        isShowLoading: true,
        schemeId: this.schemeId,
        aiBidFileList: this.aiBidFileList,
        aiQuoteFileList: this.aiQuoteFileList
      }).then(result => {
        let list = [],
          o = this.aiQuoteFileList;
        o.forEach(item => {
          if (item.packName) {
            list.push(item.packName);
          }
        });
        // if (list.length > 10) {
        //   this.$message({
        //     message: "一次最多选择10个投标文件",
        //     type: "error",
        //     duration: 3000,
        //     offset: document.documentElement.clientHeight / 2 - 21
        //   });
        //   return;
        // }
        this.showDialogVisible2 = false;
        this.getAiClearAddress(1, result.data.data.taskId);
        //// this.$message({
        //   message: "提交成功！",
        //   type: "success",
        //   duration: 3000,
        //   ccuiCustom: true,
        //   showClose: true,
        //   offset: document.body.clientHeight / 2 - 21
        // });
      });
    },
    getAiClearAddress(type, taskId) {
      getAiClearAddress({
        type: type,
        isShowLoading: true,
        taskId: taskId
      }).then(res => {
        this.AIUrl = res.data.data.address;
        // this.dialogVisible = true;
        window.open(this.AIUrl, "_blank");
      });
    },

    resetParams() {
      this.formData = {
        fileName: "",
        packName: ""
      };
    },
    selectTable(o) {
      this.aiBidFileList = o;
    },
    selectTableAll(o) {
      this.aiBidFileList = o;
    },
    selectTable2(o) {
      this.aiQuoteFileList = o;
    },
    selectTableAll2(o) {
      this.aiQuoteFileList = o;
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-searchs-bottom-form {
  .el-col-12 {
    margin-bottom: 12px;
  }
}
/deep/.yujing {
  .el-dialog__body {
    height: 70vh;
    overflow: hidden !important;
  }
}
/deep/.el-dialog__wrapper .el-dialog {
  width: 1000px !important;
}
</style>
